import { render } from "./AiImageRemove.vue?vue&type=template&id=7d423b15&scoped=true"
import script from "./AiImageRemove.vue?vue&type=script&lang=js"
export * from "./AiImageRemove.vue?vue&type=script&lang=js"

import "./AiImageRemove.vue?vue&type=style&index=0&id=7d423b15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d423b15"]])

export default __exports__